import { GridCustomCellProps } from '@progress/kendo-react-grid';
import React from 'react';
import { CpsGridCell } from './CpsGridCell';
import { useInternationalization } from '@progress/kendo-react-intl';
import { EMPTY_VALUE } from '@cs-cms/types';

const DateTimeCell: React.FC<GridCustomCellProps> = props => {
  const field = props.field || EMPTY_VALUE;
  const value = props.dataItem[field];
  const intl = useInternationalization();
  return (
    <CpsGridCell
      dataItem={props.dataItem}
      field={props.field}
      dataIndex={props.dataIndex}
      id={props.id}
      tdProps={props.tdProps}
      columnPosition={props.columnPosition}
      onChange={props.onChange}
      className={props.className}
      colSpan={props.colSpan}
      ariaColumnIndex={props.ariaColumnIndex}
      isSelected={props.isSelected}
      style={props.style}
      rowType={props.rowType}
      level={props.level}
      expanded={props.expanded}
      title={intl.formatDate(new Date(value), { date: 'full', datetime: 'medium' })}
    >
      {!value ? EMPTY_VALUE : <span>{intl.formatDate(new Date(value), { datetime: 'short' })}</span>}
    </CpsGridCell>
  );
};

export default DateTimeCell;
